import React, { useEffect, useState } from "react";
import { DrawerModal } from "../drawer-modal/drawer-modal";
import styles from "./sources-info-drawer-modal.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
//here
import { buildInputContentsObject } from "./build-input-contents-object";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
import { ReadOnlyInfoWrapperForSourcesListView } from "@src/components/molecules/read-only-info-wrapper-for-sources-list-view/read-only-info-wrapper-for-sources-list-view";
import { Title } from "@src/components/atoms/title/title";
import { DrawerIconContainer } from "@src/components/atoms/drawer-icon-container/drawer-icon-container";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import sourceBigOutlineIcon from "@src/assets/svg/source-big-outline-icon.svg";
import { useI18N } from "@src/language/language-context";

const cssClassName = "source-info-drawer-modal";

interface InputContentsTypes {
  connectivityInput: string;
  securityModeInput: string;
  securityPolicyInput: string;
}

export const SourceInfoDrawerModal = () => {
  const connectionViewState = useSelector(
    (state: RootState) => state.yourSlice.connectionView,
  );
  const [inputsContents, setInputContents] = useState<InputContentsTypes>({
    connectivityInput: "",
    securityModeInput: "",
    securityPolicyInput: "",
  });
  const i18n = useI18N();

  const texts = {
    title: i18n("modules.sourceInfoDrawerModal.title"),
    connectivity: i18n("modules.sourceInfoDrawerModal.connectivity"),
    securityMode: i18n("modules.sourceInfoDrawerModal.securityMode"),
    securityPolicy: i18n("modules.sourceInfoDrawerModal.securityPolicy"),
  };

  useEffect(() => {
    setInputContents(buildInputContentsObject("", connectionViewState));
  }, [connectionViewState]);

  return (
    <DrawerModal id={"sourceInfoDrawerModal"}>
      <div className={styles[cssClassName]}>
        <FlexColumnContainer verticalGap={32}>
          <Title text={texts.title} />
          <DrawerIconContainer icon={sourceBigOutlineIcon} />
          <div
            className={styles[`${cssClassName}__content-wrapper-connection`]}
          >
            <SubTitle text={connectionViewState.source.name} />
            <p className={styles[`${cssClassName}__server-type`]}>
              {connectionViewState.source.source_type}
            </p>
            {connectionViewState.source.dsn && (
              <ReadOnlyInfoWrapperForSourcesListView
                label={texts.connectivity}
                text={inputsContents.connectivityInput}
              />
            )}
            <ReadOnlyInfoWrapperForSourcesListView
              label={texts.securityMode}
              text={inputsContents.securityModeInput}
            />
            <ReadOnlyInfoWrapperForSourcesListView
              label={texts.securityPolicy}
              text={inputsContents.securityPolicyInput}
            />
          </div>
        </FlexColumnContainer>
      </div>
    </DrawerModal>
  );
};
